<template>
  <div>
    <div class="b-comment-user-profile">
      <section class="b-comment-user">
        <figure class="b-comment-user__avatar" :class="{'b-comment-user__avatar--no-img':!user.avatar}" v-if="!uploadImg">
          <img :src="user.avatar" v-if="user.avatar">
          <svg viewBox="0 0 40 40" v-else>
            <use xlink:href="/assets/site/images/sprites.svg?ver=19#sprite-user"></use>
          </svg>
        </figure>
        <figure class="b-comment-form__preview b-comment-form__preview--big b-comment-user__avatar" :style="{ backgroundImage: `url(${form.image})` }" v-else>
        </figure>
        <div class="b-comment-user__content">
          <h5 class="b-comment-user__title">{{user.name}}</h5>
          <p class="b-comment-user__field">
            <label class="b-comment-user__field-label">
              E-mail:
            </label>
            <span class="b-comment-user__field-val">
              {{user.email}}
            </span>
          </p>
        </div>
      </section>
      <section class="b-comment-user-profile__actions">
        <div class="b-comment-user-profile__logout">
          <button class="b-comment-user__btn" @click.prevent="logout">
            Выйти
          </button>
        </div>
        <label class="button-upload " for="user_avatar">
          <i class="button-upload__icon button-upload__icon--transparent">
            <svg viewBox="0 0 25 25">
              <use xlink:href="/assets/site/images/sprites.svg?ver=15#sprite-upload"></use>
            </svg>
          </i>
          <span class="button-upload__text button-upload__text--bold">Загрузить фото</span>
          <input type="file" name="user_avatar"  id="user_avatar" class="button-upload__input" @change="fileChangeHandler" />
        </label>
      </section>
    </div>
    <form>
      <div class="row">
        <div class="form-group col-md-6">
          <input name="name" placeholder="Новое имя" type="text" v-model="form.name" class="form-control" :class="errors.get('name') ? 'is-invalid':''">
          <div class="invalid-feedback" v-text="errors.get('name')"></div>
        </div>
        <div class="form-group col-md-6">
          <input name="password" placeholder="Новый пароль" type="text" v-model="form.password" class="form-control" :class="errors.get('password') ? 'is-invalid':''">
          <div class="invalid-feedback" v-text="errors.get('password')"></div>
        </div>
      </div>
      <section class="b-comment-user-profile__actions b-comment-user-profile__actions--mobile">

        <label class="button-upload " for="user_avatar">
          <i class="button-upload__icon button-upload__icon--transparent">
            <svg viewBox="0 0 25 25">
              <use xlink:href="/assets/site/images/sprites.svg?ver=15#sprite-upload"></use>
            </svg>
          </i>
          <span class="button-upload__text button-upload__text--bold">Загрузить фото</span>
          <input type="file" name="user_avatar"  id="user_avatar" class="button-upload__input" @change="fileChangeHandler" />
        </label>
        <div class="b-comment-user-profile__logout">
          <button class="b-comment-user__btn" @click.prevent="logout">
            Выйти
          </button>
        </div>
      </section>
      <div class="b-comment-user-profile__btns">
        <button class="btn button-red b-comment-user-profile__btn" @click.prevent="updateUser">
          Сохранить изменения
        </button>
      </div>

    </form>
  </div>
</template>
<script>
import { Errors } from  '@/common/services/errors.js';
export default {
  props:{
    user:Object,
  },
  data() {
    return {
      uploadImg:false,
      form: {
        id:this.user.id,
        name:"",
        image:"",
        password:""
      },
      errors: new Errors(),
    }

  },
  methods: {
    updateUser() {
      axios.post('/api/user-update',this.form)
      .then((response) => {
        if(response.data.errors) {
          this.errors.record(response.data.errors)
        } else {
          this.errors.clear();
          console.log(response.data)
          this.$emit('update-user', response.data);
        }
      })
      .catch((error) => {

        this.errors.record(error.response.data.errors);
      })
    },
    fileChangeHandler(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.createImage(files[0]);
      this.uploadImg = true;
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      this.form['imageName'] = file.name;
      reader.onload = (e) => {
        vm.form.image = e.target.result;

      };
      reader.readAsDataURL(file);
    },
    removeImage() {
      this.form.image = '';
    },
    logout() {
      this.$emit('logout');
    }
  }
}
</script>